<template>
  <div class="notificationTop" v-show="showNotification">
    <div class="notificationMain">
      <ul class="notificationCon" id="msg">
        <li v-for="(notice,index) in noticeInfo" :key="index"><a @click="viewNoticeInfos()">{{notice.noticeTitle}}</a></li>
      </ul>
      <span class="el-icon-close" @click="closeNotification"></span>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    props: ['noticeInfo'],
    data () {
      return {
        showNotification:true,
        int:null
      }
    },
    mounted () {
      this.scrollFn();
    },
    computed: mapState([
    'KP'
    ]),
    created () {
      if(this.getToken('isLogin') == 100){
        this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
        this.companyInfo = JSON.parse(this.getDAesString(this.getToken('companyInfo'),this.KP.key,this.KP.iv));
        this.orgId  = this.companyInfo.orgId;
        this.orgIdentityStr = this.companyInfo.orgIdentity;
        if(this.orgIdentityStr !=''){
          this.orgIdentity = this.orgIdentityStr.split(",");
        }
        this.userTag = this.userInfo.userTag;
      }
    },
    methods: {
      closeNotification(){
        this.showNotification=false;
        clearInterval(this.int);
      },
      scrollFn(){
        this.int=setInterval(this.autoScroll, 5000)
      },
      autoScroll(){
          $('#msg').animate({
              marginTop: "-32px"
            },
            3000,
            function() {
              $(this).css({
                marginTop: "0"
              }).find("li:first").appendTo(this);
            }
          );
      },
      viewNoticeInfos(){
        if(this.getToken('isLogin') == ''){
          this.$router.push({path:'/login'});
        }
        else{
            this.$router.push({ path: '/notification'})
          }
        }
      
      
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/notificationTop/index.vue